import { apiService } from "./apiService";

const SETTINGS_URL = "/settings";

export const getSettings = async (): Promise<SettingsResponse> => {
  try {
    const response = await apiService.get<SettingsResponse>(`${SETTINGS_URL}`, {});
    return response;
  } catch (error) {
    throw error;
  }
};

export const postSettings = async (data: PostSettingsProps): Promise<SettingsResponse> => {
  try {
    const response = await apiService.post<SettingsResponse>(`${SETTINGS_URL}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};